import { application, every } from './_common';

export default [
  ...every,
  ...application,

  {
    icon: 'mdi-account-group-outline',
    text: 'Пользователи',
    to: '/users',
    order: 5,
    children: [
      {
        icon: 'mdi-account-supervisor',
        text: 'Мои пользователи',
        to: '/users',
      },
      {
        text: 'Мои муниципалитеты',
        icon: 'mdi-map-marker-outline',
        to: '/municipalities',
      },
    ],
  },
];
